import _typeof from "@babel/runtime/helpers/typeof";
export var isMarkAllowedInRange = function isMarkAllowedInRange(doc, ranges, type) {
  var _loop = function _loop() {
    var _ranges$i = ranges[i],
      $from = _ranges$i.$from,
      $to = _ranges$i.$to;
    var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
    doc.nodesBetween($from.pos, $to.pos, function (node) {
      if (can) {
        return false;
      }
      can = node.inlineContent && node.type.allowsMarkType(type);
      return;
    });
    if (can) {
      return {
        v: can
      };
    }
  };
  for (var i = 0; i < ranges.length; i++) {
    var _ret = _loop();
    if (_typeof(_ret) === "object") return _ret.v;
  }
  return false;
};
export var isMarkExcluded = function isMarkExcluded(type, marks) {
  if (marks) {
    return marks.some(function (mark) {
      return mark.type !== type && mark.type.excludes(type);
    });
  }
  return false;
};